<template>
  <div class="pcb-quote">
    <!-- 顶部导航栏 -->
    <QuoteHeader />
    
    <div class="pcb-quote__container">
      <el-form 
        id="pcbQuoteForm" 
        size="small" 
        label-width="160px"
        class="pcb-quote__left"
        v-anchorNav.alignRight="isPcbSite ? {
          dir_fileInfo: 'PCB文件',
          dir_basicInfo: '基本信息',
          dir_processInfo: '工艺信息',
          dir_serviceInfo: '个性化服务',
          dir_addressInfo: '地址 / 快递',
          dir_invoiceInfo: '发票 / 支付',
          dir_smtInfo: 'SMT贴片',
        } : {}"
      >
        <!-- PCB文件 -->
        <el-collapse v-model="collapseNames" class="pcb-quote__collapse">
          <CollapseItem id="dir_fileInfo" class="pcb-quote__fileCollapseItem" name="fileInfo" :hasLinker="false">
            <template slot="title">
              <div class="pcb-quote__fileHeader">
                <div class="pcb-quote__fileHeader__label">
                  PCB文件
                  <i>*</i>
                </div>
                <div class="pcb-quote__fileHeader__operation" @click.stop>
                  <img :src="require('@@/assets/img/icons/icon_question4.png')" />
                  <BaseLink href="https://www.hqpcb.com/help/p_1904.html" target="_blank">
                    新版下单操作手册
                  </BaseLink>
                </div>
                <!-- <div class="pcb-quote__fileHeader__oldversion" @click.stop="handleBackOldVersion">
                  <img :src="require('@@/assets/img/icons/icon_back.png')" />
                  <BaseLink>
                    使用旧版
                  </BaseLink>
                </div> -->
              </div>
            </template>

            <!-- PCB文件 -->
            <pcbfile 
              ref="pcbfile"
              v-model="pcbParams.pcbfile" 
              :analyze_id.sync="pcbParams.analyze_id"
              :analyze_key.sync="analyzeKey"
              @analyzeSuccess="handleAnalyzeFile"
            />
          </CollapseItem>

          <!-- 基本信息 -->
          <CollapseItem id="dir_basicInfo" title="基本信息" name="basicInfo">
            <!-- 产品类别 -->
            <board_type 
              ref="board_type"
              v-model="pcbParams.board_type" 
              @change="handleBoardTypeChange" 
            />

            <!-- Rogers 相关字段 -->
            <template v-if="isShow.isRogers">
              <!-- 混压类型 -->
              <rogers_hybrid_type ref="hybrid_type" v-model="pcbParams.hybrid_type" />
              <!-- 板子层数 -->
              <rogers_blayer 
                ref="blayer"
                v-model="pcbParams.blayer" 
                :hybrid_type="pcbParams.hybrid_type" 
                :initPcbParamsChange="initPcbParamsChange" 
              />
              <!-- 板材型号 -->
              <rogers_board_model ref="board_model" v-model="pcbParams.board_model" />
            </template>

            <!-- FR-4 相关字段 -->
            <template v-if="isShow.isFr4">
              <!-- 板子层数 -->
              <fr4_blayer 
                ref="blayer"
                v-model="pcbParams.blayer" 
                :blind="pcbParams.blind" 
                :initPcbParamsChange="initPcbParamsChange" 
              />
              <!-- HDI(盲埋孔) -->
              <fr4_blind 
                ref="blind"
                v-model="pcbParams.blind" 
                :isHdi="isHdi" 
                :blayer="pcbParams.blayer" 
                :initPcbParamsChange="initPcbParamsChange" 
              />
              <!-- 板材 -->
              <fr4_board 
                ref="board"
                :board_brand.sync="pcbParams.board_brand" 
                :board_tg.sync="pcbParams.board_tg" 
                :board_model.sync="pcbParams.board_model" 
                :view_board.sync="pcbParams.view_board" 
                :params="{
                  blayer: pcbParams.blayer,
                  blind: pcbParams.blind,
                  bheight: pcbParams.bheight,
                  copper: pcbParams.copper,
                  insidecopper: pcbParams.insidecopper
                }"
                :initPcbParamsChange="initPcbParamsChange"
              />
            </template>

            <!-- 铝基板 相关字段 -->
            <template v-if="isShow.isAlu">
              <!-- 铝基板结构 -->
              <alu_aluminium_board_type 
                ref="aluminium_board_type"
                v-model="pcbParams.aluminium_board_type" 
              />
              <!-- 板子层数 -->
              <alu_blayer 
                ref="blayer"
                v-model="pcbParams.blayer" 
                :aluminium_board_type="pcbParams.aluminium_board_type" 
              />
              <!-- 板材 -->
              <alu_board 
                ref="board"
                :board_brand.sync="pcbParams.board_brand" 
                :board_tg.sync="pcbParams.board_tg" 
                :board_model.sync="pcbParams.board_model" 
                :view_board.sync="pcbParams.view_board" 
                :initPcbParamsChange="initPcbParamsChange"
              />
            </template>

            <!-- 铜基板 相关字段 -->
            <template v-if="isShow.isCopper">
              <!-- 铜基板结构 -->
              <copper_copper_board_type 
                ref="copper_board_type"
                v-model="pcbParams.copper_board_type" 
              />
              <!-- 板子层数 -->
              <copper_blayer 
                ref="blayer"
                v-model="pcbParams.blayer" 
                :copper_board_type="pcbParams.copper_board_type" 
              />
              <!-- TG值 -->
              <copper_board_tg 
                ref="board_tg"
                v-model="pcbParams.board_tg" 
              />
            </template>

            <!-- 拼板款数 -->
            <pbnum ref="pbnum" v-model="pcbParams.pbnum" />

            <!-- 出货形式 -->
            <units 
              ref="units"
              v-model="pcbParams.units" 
              @open="handleOpenBoardDialog"
              @reset="handleResetBoard"
            />

            <!-- 连片类型 -->
            <delivery_sub_units 
              v-if="isShow.delivery_sub_units"
              ref="delivery_sub_units"
              v-model="pcbParams.delivery_sub_units" 
            />

            <!-- 尺寸 -->
            <length 
              ref="length" 
              :length.sync="pcbParams.length" 
              :width.sync="pcbParams.width" 
              :units="pcbParams.units" 
              :disabled="isDisabledBoardParams"
            />

            <!-- 拼板规则 -->
            <layout
              v-if="isShow.layout"
              ref="layout"
              :layoutx.sync="pcbParams.layoutx"
              :layouty.sync="pcbParams.layouty"
              :exampleData="{
                setlength: computePcbSize.length,
                setwidth: computePcbSize.width,
                length: pcbParams.length,
                width: pcbParams.width,
                layouty: pcbParams.layouty,
                layoutx: pcbParams.layoutx,
                bcount: pcbParams.bcount,
                pcsNum: pcsNumForSet,
                m: pcbPrice.m
              }"
              :disabled="isDisabledBoardParams"
            />

            <!-- 数量 -->
            <bcount 
              ref="bcount"
              v-model="pcbParams.bcount" 
              :blayer="pcbParams.blayer" 
              :units="pcbParams.units" 
              :setlength="computePcbSize.length"
              :setwidth="computePcbSize.width"
              :pcsNum="pcsNumForSet" 
              :area="pcbPrice.m"
              :ladderPriceData="{
                blayer: pcbParams.blayer,
                length: computePcbSize.length,
                width: computePcbSize.width,
                bcount: pcbParams.bcount,
                bheight: pcbParams.bheight
              }"
              :board_type="pcbParams.board_type"
              @tipsChange="tips => ladderPriceTips = tips"
            />
            
            <!-- 工艺边框 -->
            <sidewidth 
              ref="sidewidth" 
              v-if="isShow.sidewidth" 
              :sidedirection.sync="pcbParams.sidedirection" 
              :sidewidth.sync="pcbParams.sidewidth" 
              :disabled="isDisabledBoardParams"
              :hasDfmSets="hasDfmSets"
              :dfm_sets="pcbParams.dfm_sets"
            />
          </CollapseItem>

          <!-- 工艺信息 -->
          <CollapseItem id="dir_processInfo" title="工艺信息"  name="processInfo">
            <!-- 板子厚度 -->
            <component 
              :is="getComponentName('bheight')"
              ref="bheight"
              v-model="pcbParams.bheight"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  copper: pcbParams.copper,
                  insidecopper: pcbParams.insidecopper,
                  color: pcbParams.color,
                  bankong: pcbParams.bankong,
                  baobian: pcbParams.baobian,
                  vias: pcbParams.vias,
                  area: area,
                  initPcbParamsChange: initPcbParamsChange,
                  initDefaultPcbParamsChange: initDefaultPcbParamsChange
                },
                'ROGERS': {
                  blayer: pcbParams.blayer,
                  board_model: pcbParams.board_model,
                  initPcbParamsChange: initPcbParamsChange,
                  initDefaultPcbParamsChange: initDefaultPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 外层铜厚 -->
            <component 
              :is="getComponentName('copper')"
              ref="copper"
              v-model="pcbParams.copper"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  blind: pcbParams.blind,
                  area: area,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {
                  blayer: pcbParams.blayer,
                  initPcbParamsChange: initPcbParamsChange
                },
                'COPPER': {
                  blayer: pcbParams.blayer,
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 内层铜厚 -->
            <component 
              v-if="isShow.insidecopper"
              ref="insidecopper"
              :is="getComponentName('insidecopper')"
              v-model="pcbParams.insidecopper"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  blind: pcbParams.blind,
                  copper: pcbParams.copper,
                  bheight: pcbParams.bheight,
                  area: area,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {},
                'COPPER': {
                  blayer: pcbParams.blayer,
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 铜基结构 -->
            <copper_copper_structure 
              v-if="isShow.copper_structure"
              ref="copper_structure"
              v-model="pcbParams.copper_structure"
            />

            <!-- 导热系数 -->
            <component 
              v-if="isShow.heat_factor"
              ref="heat_factor"
              :is="getComponentName('heat_factor')"
              v-model="pcbParams.heat_factor"
              v-bind="{
                'ALU': {
                  initPcbParamsChange: initPcbParamsChange
                },
                'COPPER': {
                  copper_structure: pcbParams.copper_structure,
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 板材耐压值 -->
            <alu_withstand_value 
              v-if="isShow.withstand_value"
              ref="withstand_value"
              v-model="pcbParams.withstand_value"
            />

            <!-- 最小线宽线距 -->
            <component 
              :is="getComponentName('lineweight')"
              ref="lineweight"
              v-model="pcbParams.lineweight"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  blind: pcbParams.blind,
                  copper: pcbParams.copper,
                  insidecopper: pcbParams.insidecopper,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {
                  copper: pcbParams.copper,
                  area: area,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ALU': {
                  copper: pcbParams.copper,
                  initPcbParamsChange: initPcbParamsChange
                },
                'COPPER': {
                  blayer: pcbParams.blayer,
                  copper: pcbParams.copper,
                  insidecopper: pcbParams.insidecopper,
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 最小孔径 -->
            <component 
              :is="getComponentName('vias')"
              ref="vias"
              v-model="pcbParams.vias"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  blind: pcbParams.blind,
                  bheight: pcbParams.bheight,
                  copper: pcbParams.copper,
                  insidecopper: pcbParams.insidecopper,
                  color: pcbParams.color,
                  area: area,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {
                  bheight: pcbParams.bheight,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ALU': {
                  bheight: pcbParams.bheight,
                  initPcbParamsChange: initPcbParamsChange
                },
                'COPPER': {
                  bheight: pcbParams.bheight,
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 阻焊颜色 -->
            <component 
              :is="getComponentName('color')"
              ref="color"
              v-model="pcbParams.color"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  bheight: pcbParams.bheight,
                  copper: pcbParams.copper,
                  vias: pcbParams.vias,
                  blind: pcbParams.blind,
                  area: area,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 字符颜色 -->
            <component 
              :is="getComponentName('charcolor')"
              ref="charcolor"
              v-model="pcbParams.charcolor"
              :color="pcbParams.color"
              :initPcbParamsChange="initPcbParamsChange"
            />

            <!-- 阻焊覆盖 -->
            <component 
              v-if="isShow.cover"
              :is="getComponentName('cover')"
              ref="cover"
              v-model="pcbParams.cover"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  copper: pcbParams.copper,
                  insidecopper: pcbParams.insidecopper,
                  spray: pcbParams.spray,
                  via_in_pad: pcbParams.via_in_pad,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {
                  initPcbParamsChange: initPcbParamsChange
                },
                'ALU': {
                  initPcbParamsChange: initPcbParamsChange
                },
                'COPPER': {
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 盘中孔-->
            <via_in_pad
              v-if="isShow.via_in_pad"
              ref="via_in_pad"
              v-model="pcbParams.via_in_pad"
              :blayer="pcbParams.blayer"
              :copper="pcbParams.copper"
              :insidecopper="pcbParams.insidecopper"
              :initPcbParamsChange="initPcbParamsChange" 
            />

            <!-- 表面处理 -->
            <component 
              :is="getComponentName('spray')"
              ref="spray"
              v-model="pcbParams.spray"
              v-bind="{
                'FR-4': {
                  blayer: pcbParams.blayer,
                  blind: pcbParams.blind,
                  bankong: pcbParams.bankong,
                  baobian: pcbParams.baobian,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 沉金厚度 -->
            <component 
              v-if="isShow.cjh"
              :is="getComponentName('cjh')"
              ref="cjh"
              v-model="pcbParams.cjh"
              v-bind="{
                'FR-4': {
                  manufacture: manufacture,
                  initPcbParamsChange: initPcbParamsChange
                },
                'ROGERS': {
                  initPcbParamsChange: initPcbParamsChange
                },
                'ALU': {
                  initPcbParamsChange: initPcbParamsChange
                },
                'COPPER': {
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 成型方式 -->
            <component 
              v-if="isShow.forming_method"
              :is="getComponentName('forming_method')"
              ref="forming_method"
              v-model="pcbParams.forming_method"
            />

            <!-- 沉头孔 -->
            <component 
              v-if="isShow.countersunk_hole"
              :is="getComponentName('countersunk_hole')"
              ref="countersunk_hole"
              v-model="pcbParams.countersunk_hole"
              v-bind="{
                'ALU': {
                  bheight: pcbParams.bheight,
                  initPcbParamsChange: initPcbParamsChange
                },
                'COPPER': {
                  bheight: pcbParams.bheight,
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 层压顺序 -->
            <overlay_type
              v-if="isShow.overlay_type"
              ref="overlay_type"
              :overlay_type.sync="pcbParams.overlay_type"
              :overlay_seq.sync="pcbParams.overlay_seq"
            />

            <!-- 阻抗 -->
            <impendance 
              v-if="isShow.impendance"
              ref="impendance"
              v-model="pcbParams.impendance" 
              :blayer="pcbParams.blayer"
              :copper="pcbParams.copper" 
              :pressing="pcbParams.pressing"
              :showTips="isShow.isFr4"
              :initPcbParamsChange="initPcbParamsChange"
            />

            <!-- 叠层结构 -->
            <component 
              v-if="isShow.pressing"
              :is="getComponentName('pressing')"
              ref="pressing"
              v-model="pcbParams.pressing"
              v-bind="{
                'FR-4': {
                  params: { 
                    blayer: pcbParams.blayer, 
                    bheight: pcbParams.bheight, 
                    copper: pcbParams.copper, 
                    insidecopper: pcbParams.insidecopper, 
                    hdi: pcbParams.blind,
                    impendance: pcbParams.impendance
                  },
                  pressingData: pcbParams.pressing_data,
                  spec_discount: pcbPrice.spec_discount
                },
                'ROGERS': {
                  initPcbParamsChange: initPcbParamsChange
                }
              }[componentType] || {}"
            />

            <!-- 手指斜边 -->
            <beveledge 
              v-if="isShow.beveledge"
              ref="beveledge"
              v-model="pcbParams.beveledge" 
              :board_type="pcbParams.board_type"
              :pcb-size="computePcbSize" 
            />

            <!-- 半孔 -->
            <bankong 
              v-if="isShow.bankong"
              ref="bankong"
              v-model="pcbParams.bankong" 
              :blayer="pcbParams.blayer"
              :press_fit_hole="isShow.press_fit_hole ? pcbParams.press_fit_hole : 0"
              :initPcbParamsChange="initPcbParamsChange"  
            />

            <!-- 包边 -->
            <baobian 
              v-if="isShow.baobian"
              ref="baobian"
              v-model="pcbParams.baobian" 
              :blayer="pcbParams.blayer"
              :press_fit_hole="isShow.press_fit_hole ? pcbParams.press_fit_hole : 0"
              :initPcbParamsChange="initPcbParamsChange"  
            />

            <!-- 压接孔 -->
            <press_fit_hole 
              v-if="isShow.press_fit_hole"
              ret="press_fit_hole"
              v-model="pcbParams.press_fit_hole" 
              :spray="pcbParams.spray"
              :bankong="pcbParams.bankong"
              :baobian="pcbParams.baobian"
              :initPcbParamsChange="initPcbParamsChange"  
            />

            <!-- 蓝胶 -->
            <rogers_blue_glue 
              v-if="isShow.blue_glue" 
              ref="blue_glue"
              v-model="pcbParams.blue_glue" 
            />

            <!-- 碳油 -->
            <rogers_carbon_oil 
              v-if="isShow.carbon_oil" 
              ref="carbon_oil"
              v-model="pcbParams.carbon_oil" 
            />

            <!-- 测试方式 -->
            <component 
              :is="getComponentName('test')" 
              v-model="pcbParams.test"
              ref="test"
              :view_test.sync="pcbParams.view_test"
              :testOptions="testOptions"
              :loading="calcLoading"
            />

          </CollapseItem>

          <!-- 个性化服务 -->
          <CollapseItem id="dir_serviceInfo" title="个性化服务"  name="serviceInfo">
            <!-- 确认生产稿 -->
            <review_file 
              ref="review_file" 
              v-model="pcbParams.review_file" 
              :board_type="pcbParams.board_type"
              :blayer="pcbParams.blayer"
              :user_stamp="pcbParams.user_stamp"
              :panelize_method="pcbParams.panelize_method"
              :initPcbParamsChange="initPcbParamsChange"
            />

            <!-- 四线低阻过孔 -->
            <fr4_four_terminal
              v-if="isShow.four_terminal" 
              ref="four_terminal"
              v-model="pcbParams.four_terminal" 
              :blind="pcbParams.blind" 
              :blayer="pcbParams.blayer" 
              :initPcbParamsChange="initPcbParamsChange" 
            />

            <!-- 华秋标识和制造周期 -->
            <has_period 
              ref="has_period" 
              v-model="pcbParams.has_period" 
              :period_format="pcbParams.period_format" 
              :board_type="pcbParams.board_type"
              :hideOptions="!isShow.isFr4 ? [5] : []"
            />

            <!-- 周期格式 -->
            <period_format 
              v-if="isShow.period_format" 
              ref="period_format" 
              v-model="pcbParams.period_format" 
              :board_type="pcbParams.board_type"
            />

            <!-- 客编 -->
            <user_stamp 
              ref="user_stamp" 
              v-model="pcbParams.user_stamp" 
              :board_type="pcbParams.board_type"
            />

            <!-- 打叉板 -->
            <cross_board 
              ref="cross_board"
              v-model="pcbParams.cross_board" 
              :board_type="pcbParams.board_type"
            />

            <!-- 工程EQ处理方式 -->
            <eq_notice 
              ref="eq_notice" 
              v-model="pcbParams.eq_notice" 
              :board_type="pcbParams.board_type"
            />

            <!-- 工程师信息 -->
            <engineer_id 
              v-if="isShow.engineer_id"
              ref="engineer_id"
              v-model="pcbParams.engineer_id" 
              :view_engineer_id.sync="pcbParams.view_engineer_id"
            />

            <!-- 少数处理方式 -->
            <fr4_lack_handle_type 
              v-if="isShow.lack_handle_type"
              ref="lack_handle_type" 
              :lack_handle_type.sync="pcbParams.lack_handle_type"
              :lack_handle_number_type.sync="pcbParams.lack_handle_number_type"
              :lack_handle_number.sync="pcbParams.lack_handle_number"
              :lack_handle_number_unit.sync="pcbParams.lack_handle_number_unit"
              :lack_handle_shipping_type.sync="pcbParams.lack_handle_shipping_type"
              :units="pcbParams.units" 
              :bcount="pcbParams.bcount" 
              :layouty="pcbParams.layouty" 
              :layoutx="pcbParams.layoutx" 
              :length="pcbParams.length" 
              :width="pcbParams.width" 
              :getLackhandlefee="getLackhandlefee"
            />

            <!-- 品质赔付方式 -->
            <fr4_insurance_type 
              v-if="isShow.insurance_type"
              ref="insurance_type"
              :insurance_type.sync="pcbParams.insurance_type" 
              :insurance.sync="pcbParams.insurance" 
              :pcbParams="pcbParams"
            />

            <!-- 产品报告 -->
            <report 
              v-model="pcbParams.report" 
              ref="report"
              :blayer="pcbParams.blayer" 
              :impendance="isShow.impendance ? pcbParams.impendance : 0"
              :initPcbParamsChange="initPcbParamsChange" 
            />

            <!-- 报告形式 -->
            <report_type 
              ref="report_type" 
              v-if="isShow.report_type" 
              v-model="pcbParams.report_type" 
            />

            <!-- 隔白纸 -->
            <paper 
              ref="paper"
              v-model="pcbParams.paper"
              :length="pcbParams.length" 
              :width="pcbParams.width"
            />

            <!-- 内标签 -->
            <fr4_inner_box_label 
              v-if="isShow.inner_box_label"
              ref="inner_box_label"
              :inner_box_label.sync="pcbParams.inner_box_label" 
              :custom_id.sync="pcbParams.custom_id" 
              :custom_name.sync="pcbParams.custom_name" 
              :initPcbParamsChange="initPcbParamsChange" 
            />

            <!-- 内包装标签备注 -->
            <label_remark 
              v-if="isShow.label_remark"
              ref="label_remark" 
              v-model="pcbParams.label_remark" 
            />

            <!-- 纸箱要求 -->
            <hq_pack 
              ref="hq_pack" 
              v-model="pcbParams.hq_pack" 
              :board_type="pcbParams.board_type"
            />

            <!-- 审核通知 -->
            <sh 
              ref="sh"
              v-model="pcbParams.sh" 
              :board_type="pcbParams.board_type"
            />

            <!-- PCB 下单人 -->
            <orderman_id 
              ref="orderman_id"
              v-model="pcbParams.orderman_id" 
              :orderman.sync="pcbParams.orderman" 
              :ordertel.sync="pcbParams.ordertel" 
              :initPcbParamsChange="initPcbParamsChange" 
            />

            <!-- PCB订单备注 -->
            <note 
              ref="note"
              v-model="pcbParams.note" 
              :isShowGchTips="pcbPrice.engineering_standard_file == 2" 
            />

          </CollapseItem>

          <!-- 地址 / 快递 -->
          <CollapseItem id="dir_addressInfo" title="地址 / 快递"  name="addressInfo">
            <!-- 发货通知 -->
            <fh 
              ref="fh"
              v-model="pcbParams.fh" 
              :board_type="pcbParams.board_type"
            />

            <!-- 送货单 -->
            <fhp 
              ref="fhp"
              :fhp.sync="pcbParams.fhp" 
              :fhd_title.sync="pcbParams.fhd_title" 
            />

            <!-- 收货地址 -->
            <aid 
              ref="aid"
              :aid="pcbParams.aid" 
              :initPcbParamsChange="initPcbParamsChange" 
              @change="handleAddressChange" 
            />

            <!-- 快递公司 -->
            <express
              ref="express"
              v-model="pcbParams.express" 
              :view_express.sync="pcbParams.view_express"
              :express="pcbParams.express"
              :params="formatPcbParams(pcbParams)" 
              :weight="pcbPrice.weight"
            />

          </CollapseItem>

          <!-- 发票 / 支付 -->
          <CollapseItem id="dir_invoiceInfo" title="发票 / 支付"  name="invoiceInfo">
            <template slot="title">
              <div class="pcb-quote__invoiceHeader">
                发票 / 支付
                <span>每张订单只能申请一次发票，请仔细核对</span>
              </div>
            </template>

            <!-- 开票类型 -->
            <invoice 
              ref="invoice"
              v-model="pcbParams.invoice" 
            />

            <!-- 发票抬头 -->
            <bill_id 
              v-if="isShow.bill_id"
              ref="bill_id"
              v-model="pcbParams.bill_id" 
              :type="{ '普票': 2, '增票全电': 1 }[pcbParams.invoice]"
              @change="handleInvoiceChange"
            />
            
            <!-- 订单支付方式 -->
            <deduct_type 
              ref="deduct_type"
              :deduct_type.sync="pcbParams.deduct_type" 
              :deduct_limit.sync="pcbParams.deduct_limit" 
              :price-total="priceTotal.total_amount"
            />

          </CollapseItem>

          <!-- SMT贴片 -->
          <CollapseItem id="dir_smtInfo" title="SMT贴片"  name="smtInfo">
            <template slot="title">
              <div class="pcb-quote__smtInfoHeader">
                SMT贴片
                <BaseTipPopover width="400px">
                  <img 
                    width="100%"
                    :src="require('@@/assets/img/pcb/is_need_smt_tips.png')" 
                  />
                  <span slot="reference" class="pcb-quote__smtInfoHeader__text">首单50套内 免费贴片</span>
                </BaseTipPopover>
              </div>
            </template>

            <!-- SMT贴片 -->
            <is_need_smt 
              ref="is_need_smt" 
              v-model="pcbParams.is_need_smt" 
              :pcbParams="pcbParams" 
              @reviewFileChange="val => pcbParams.review_file = val"
            />
          </CollapseItem>

        </el-collapse>
      </el-form>

      <!-- 右边栏 -->
      <affix :offset="86" relativeContainerId="pcbQuoteForm">
        <div class="pcb-quote__right">
          <!-- 3D 预览 -->
          <Iframe3D 
            :analyzeId="pcbParams.analyze_id"
            :analyzeKey="analyzeKey"
            :params="{
              type: pcbParams.board_type,
              height: pcbParams.bheight,
              color: pcbParams.color,
              pad: pcbParams.spray
            }"
          />
          <!-- 右边栏 -->
          <!-- @scroll @shake 从 checkOrder/index.vue 传递 -->
          <Right 
            @validate="handleValidate"
            @scroll="scrollIntoView"
            @shake="handleShake"
          />
        </div>
      </affix>
    </div>

    <!-- 右侧悬浮专属客服 -->
    <AffixService v-if="isPcbSite" />
    <!-- 拼板工具弹框 -->
    <BoardDialog 
      ref="BoardDialogRef" 
      :pcbParams="pcbParams" 
      :hasDfmSets="hasDfmSets"
      @confirm="handleBoardConfirm"
      @cancel="handleBoardCancel"
    />
  </div>
</template>

<script>
// 顶部导航栏
import QuoteHeader from './components/QuoteHeader'
// 右侧固钉悬浮
import Affix from '@@/components/affix/index'
// 拼板工具弹框
import BoardDialog from '@@/views/pcb/components/boardDialog/index'
// 折叠面板
import CollapseItem from './components/collapseItem'
// 计价页右侧 3D渲染iframe
import Iframe3D from './components/iframe3D'
// 右边栏
import Right from './right/index'
// 右侧悬浮专属客服
import AffixService from '@@/views/pcb/components/affixService.vue'


import { isPcbSite } from '@@/utils/is'
import { sensorsTrack } from '@@/utils/sensors'
import { debounce } from '@@/utils/utils'
import { scrollTop } from '@@/utils/pageScroll'
import { getNumberOptionKeys } from '@@/utils/getFields'
import { anchorNav } from '@@/utils/directives'
import { registerComponents } from '@@/utils/registerComponents'
import { UNCHANGED_FIELDS } from '@@/utils/constant'
import { getBefoerLoginPcbParams, removeBefoerLoginPcbParams } from './components/notLogin'
import { 
  FR4_DEFAULT_FORM, 
  PCB_DEFAULT_FORM,
  HDI_DEFAULT_FORM, 
  ROGERS_DEFAULT_FORM,
  FR4_BOARD_DEFAULT_FORM
} from '@@/utils/defaultForm'
import {
  isShowPcbParams,
  computePcbSize,
  pcsNumForSet,
  formatPcbParams
} from '@@/utils/pcbQuoteFormat'
import { 
  getPcbPrice 
} from '@@/api/pcb'

// 自动引入 fields 下的组件（共用组件）
const fieldsComponents = require.context('@@/views/pcbQuote/fields', true, /\.vue$/)
// 自动引入 fr4Fields 下的组件（FR-4组件）
const fr4FieldsComponents = require.context('@@/views/pcbQuote/fr4Fields', true, /\.vue$/)
// 自动引入 rogersFields 下的组件（ROGERS组件）
const rogersFieldsComponents = require.context('@@/views/pcbQuote/rogersFields', true, /\.vue$/)
// 自动引入 aluFields 下的组件（铝基板组件）
const aluFieldsComponents = require.context('@@/views/pcbQuote/aluFields', true, /\.vue$/)
// 自动引入 copperFields 下的组件（铜基板组件）
const copperFieldsComponents = require.context('@@/views/pcbQuote/copperFields', true, /\.vue$/)

// 默认展开所有折叠面板
const defaultExpandCollapseNames = ['fileInfo', 'basicInfo', 'processInfo', 'serviceInfo', 'addressInfo', 'invoiceInfo', 'smtInfo']

export default {
  components: {
    ...registerComponents(fieldsComponents),
    ...registerComponents(fr4FieldsComponents, 'fr4_'),
    ...registerComponents(rogersFieldsComponents, 'rogers_'),
    ...registerComponents(aluFieldsComponents, 'alu_'),
    ...registerComponents(copperFieldsComponents, 'copper_'),
    QuoteHeader,
    Affix,
    CollapseItem,
    Right,
    BoardDialog,
    Iframe3D,
    AffixService
  },
  directives: {
    anchorNav
  },
  // 向右侧侧边栏注入订单参数
  provide() {
    return {
      pcbParams: this.pcbParams,
      getPcbPrice: () => this.pcbPrice,
      getPriceTotal: () => this.priceTotal,
      pcbValidate: valids => this.validate(valids)
    }
  },
  data() {
    return {
      calcLoading: false, // 计价loading
      collapseNames: [...defaultExpandCollapseNames], // 折叠面板
      analyzeKey: 0, // PCB多文件解析索引
      pcbParams: { 
        ...FR4_DEFAULT_FORM,
        agreen_disclaimers: true, // 免责声明
      },
      manufacture: 1, // 外发等于0
      pcbPrice: {}, // PCB价格
      priceTotal: {}, // 订单总计价格
      testOptions: [], // 测试方式选项
      debounceGetPirce: debounce(this.getPrice, 500), // 计价接口防抖
      initPcbParamsChange: true, // 初始化参数时，参数不进行关联变更
      initDefaultPcbParamsChange: false, // 配置的初始化默认参数变更时
      ladderPriceTips: '', // 阶梯价提示
      debounceGetExpress: debounce(this.handleGetExpressList, 300), // 获取快递列表防抖
    }
  },
  computed: {
    // PCB站点
    isPcbSite() {
      return isPcbSite
    },
    // 相关字段是否显示判断
    isShow() {
      return isShowPcbParams(this.pcbParams)
    },
    // 是否需要SMT贴片
    isNeedSmt() {
      // return this.pcbParams.is_need_smt === 1
      // PCB下单与【smt贴片】字段不再交互
      return false
    },
    // 是否是从二级导航栏点击 HDI板计价 跳转过来的
    isHdi() {
      return this.$route.query.hdi == 1 || this.$route.query.board_type == 'HDI'
    },
    // 是否有DFM传值过来的json
    hasDfmSets() {
      return !!this.pcbParams.dfm_sets
    },
    // 板子面积
    area() {
      const { computePcbSize, pcbParams, pcbPrice } = this
      // 当计价接口还没返回时，使用拼板长宽计算面积
      return (pcbPrice.m || (computePcbSize.length * computePcbSize.width * pcbParams.bcount) || 0) / 10000
    },
    // 计算板子尺寸
    computePcbSize() {
      return computePcbSize(this.pcbParams)
    },
    // 连片数量换算为单片数量
    pcsNumForSet() {
      return pcsNumForSet(this.pcbParams)
    },
    // 是否禁用拼板工具相关参数
    isDisabledBoardParams() {
      // 出货形式是 连片(华秋代拼) 时，需要禁用拼板工具相关的参数
      return this.pcbParams.units == 2
    },
    // 产品类别对应的组件名
    componentType() {
      return this.pcbParams.board_type
    }
  },
  watch: {
    pcbParams: {
      deep: true,
      handler: function (val) {
        // 计价
        this.debounceGetPirce()
        // 快递列表
        // this.debounceGetExpress()
      }
    },
    // 预估重量
    'pcbPrice.weight'() {
      // 快递列表
      this.debounceGetExpress()
    }
  },
  async mounted() {
    let { id, board_type, hdi } = this.$route.query

    // 获取登录前缓存的参数
    const beforeLoginPcbParams = getBefoerLoginPcbParams()
    if (beforeLoginPcbParams) {
      this.$store.dispatch('defaultValueConfig/getPcbDefaultValueConfig')
      // 删除登录前缓存的参数
      removeBefoerLoginPcbParams()
      // 填充登录前缓存的参数
      this.initBeforeLoginParams(beforeLoginPcbParams)
    } else {
      await this.initDefaultValueConfig()
      if (board_type || hdi) {
        // 兼容旧的跳转参数
        if (hdi == 1) {
          // 填充HDI默认参数
          this.initDefaultParams('HDI')
        } else {
          // 暂时只支持 FR-4 ROGERS ALU COPPER HDI
          if (['FR-4', 'ROGERS', 'ALU', 'COPPER', 'HDI'].includes(board_type)) {
            this.initDefaultParams(board_type)
          } else {
            const path = board_type === 'FPC' ? '/quote_new/fpc/' : `/quote_new?board_type=${board_type}`
            // 新窗口打开
            window.open(path)
          }
        }
      } else {
        this.initUrlParams()
      }
    }

    // 需要等待设置 isLogin 的值后在执行
    await this.$store.dispatch('orderUser/getIsLogin')
    this.$nextTick(() => {
      this.delayInit()
      this.initPcbParamsChange = false
    })

    // 神策数据埋点
    sensorsTrack('PCB1_quotation_order_view', { entrance: '新版PCB计价页面浏览' })
  },
  methods: {
    formatPcbParams,
    // 获取对应产品类别的组件名称
    getComponentName(component) {
      const componentType = this.componentType
      // 需要额外处理的字段
      const fieldComponent = {
        // 字符颜色
        charcolor: { 'ALU': 'alu_', 'COPPER': 'copper_' }[componentType] || '',
        // 测试方式
        test: { 'ALU': 'alu_' }[componentType] || ''
      }
      const prefix = fieldComponent.hasOwnProperty(component) 
        ? fieldComponent[component] 
        : {
          'FR-4': 'fr4_',
          'ROGERS': 'rogers_',
          'ALU': 'alu_',
          'COPPER': 'copper_',
        }[componentType] || ''

      return prefix + component
    },
    // 需要转为 Number 类型的字段
    transformNumberFields(type, params) {
      const fields = Array.isArray(type) 
        ? type.reduce((keys, key) => [...new Set([...keys, ...getNumberOptionKeys(key)])], []) 
        : getNumberOptionKeys(type)

      return fields.reduce((data, key) => {
        if (params[key] !== undefined) {
          data[key] = Number(params[key])
        }
        return data
      }, {})
    },
    // 填充配置的初始化参数
    async initDefaultValueConfig() {
      // const isLogin = this.$store.state.orderUser.isLogin
      // if (!isLogin) return
      this.loading = true
      this.initDefaultPcbParamsChange = true
      await this.$store.dispatch('defaultValueConfig/getPcbDefaultValueConfig')
      const defaultValueConfig = this.$store.state.defaultValueConfig.PCB || {}
      const numberFields = getNumberOptionKeys('FR-4')
      const configData = Object.entries(defaultValueConfig).reduce((data, [key, val]) => {
        if (['none', 'default'].includes(val)) {
          data[key] = { 'none': '', 'default': FR4_DEFAULT_FORM[key] }[val]
        } else if (numberFields.includes(key)) {
          data[key] = Number(val)
        } else {
          data[key] = val
        }
        return data
      }, {})
      this.pcbParams = Object.assign(this.pcbParams, configData)
      this.loading = false
      this.$nextTick(() => {
        this.initDefaultPcbParamsChange = false
      })
    },
    // 填充默认参数
    initDefaultParams(board_type) { 
      this.initPcbParamsChange = true
      this.pcbParams = Object.assign(this.pcbParams, PCB_DEFAULT_FORM[board_type] || {})
      this.$nextTick(() => {
        this.initPcbParamsChange = false
      })
    },
    // 填充url参数
    initUrlParams() {
      const routeQuery = this.$route.query
      // 需要添加 b 前缀的key
      const otherUrlParamKeys = ['count', 'layer', 'height', 'lind']
      const urlParamKeys = ['length', 'width', 'blayer', 'bcount', 'bheight', 'lineweight', ...otherUrlParamKeys]

      if (!urlParamKeys.some(key => routeQuery[key])) return

      // 数字类型的字段
      const numberFields = getNumberOptionKeys(['FR-4'])
      // 当url有带参数时，填充参数
      this.initPcbParamsChange = true
      const urlData = urlParamKeys.reduce((data, key) => {
        const val = routeQuery[key]
        const paramKey = otherUrlParamKeys.includes(key) ? `b${key}` : key
        data[paramKey] = val ? (numberFields.includes(paramKey) ? +val : val) : FR4_DEFAULT_FORM[paramKey]
        return data
      }, {})
      this.pcbParams = Object.assign(this.pcbParams, urlData)
      this.$nextTick(() => {
        this.initPcbParamsChange = false
      })
    },
    // 填充登录前缓存的参数
    initBeforeLoginParams(beforeLoginPcbParams) {
      this.initPcbParams(JSON.parse(beforeLoginPcbParams))
    },
    // PCB参数处理
    initPcbParams(params) {
      if (params) {
        this.initPcbParamsChange = true
        const transformNumberFields = this.transformNumberFields(['FR-4', 'ROGERS'], params)
        const { report, pressing, pressing_computer_id, pressing_data, board_type, lack_handle_number } = params
        this.pcbParams = Object.assign(this.pcbParams, params, transformNumberFields, {
          // 产品报告
          report: report ? (Array.isArray(report) ? report : report.split(',')) : ['无需'],
          // 叠层结构：当有计算id时，前端拼上计算id，用于区分接口返回的选项
          // 罗杰斯 为空时 选中 无需求
          pressing: pressing_computer_id ? `${pressing_computer_id}__${pressing}` : (board_type === 'ROGERS' ? pressing || '无需求' : pressing),
          // 叠层结构计算选项查看数据
          pressing_data: pressing_computer_id ? pressing_data : null,
          // 少数占比大于(如果返回 0 则置空)
          lack_handle_number: lack_handle_number || '',
        })
      }
      
      this.$nextTick(() => {
        this.initPcbParamsChange = false
        // this.delayInit()
      })
    },

    // 文件解析成功
    handleAnalyzeFile(data) {
      const { file_type, blength, bwidth, blayer } = data || {}
      const { isRogers, isAlu, isCopper } = this.isShow

      // 解析成功
      if (file_type != -1) {
        // 解析的板子层数为 2 且 罗杰斯的混压类型为 混压 时，将混压类型改为 纯压
        if (this.isShow.isRogers && data.blayer == 2 && this.pcbParams.hybrid_type == 2) {
          data.hybrid_type = 1
          this.$topWarning.mergeFields('混压类型')
        }
        
        if (
          // 罗杰斯 解析的板子层数不在板子层数选项中 或 为禁用选项时
          (isRogers && ![2, 4, 6].includes(blayer)) || 
          // 铝基板 解析的板子层数不在板子层数选项中 或 为禁用选项时
          (isAlu && (![1, 2].includes(blayer) || (this.pcbParams.aluminium_board_type == 2 && blayer == 1))) || 
          // 铜基板 解析的板子层数不在板子层数选项中 或 为禁用选项时
          (isCopper && (![1, 2, 4, 6, 8].includes(blayer) || (this.pcbParams.copper_board_type == 2 && [1, 6, 8].includes(blayer))))
        ) {
          data.blayer = this.pcbParams.blayer
          this.$alert(`文件为${blayer}层板，华秋暂不支持`, '温馨提示', {
            confirmButtonText: '好的',
            lockScroll: false,
            center: true,
            customClass: 'alert-fields-tips',
            closeOnPressEscape: true
          })
        }
      }
      
      // 解析成功后，需要先重置拼板工具相关的字段
      this.pcbParams = Object.assign(
        this.pcbParams, 
        FR4_BOARD_DEFAULT_FORM, 
        data, 
        (file_type === -1 ? { length: this.pcbParams.length, width: this.pcbParams.width } : { length: blength, width: bwidth })
      )
    },
    // 产品类别切换
    handleBoardTypeChange(val) {
      const defaultForm = PCB_DEFAULT_FORM[val] || {}
      // 需要保留的字段
      const unchangedForm = UNCHANGED_FIELDS.reduce((pre, cur) => {
        pre[cur] = this.pcbParams[cur]
        return pre
      }, {})

      this.pcbParams = Object.assign(this.pcbParams, defaultForm, unchangedForm)
    },

    // 显示拼板工具弹框
    handleOpenBoardDialog(preUnits) {
      this.$refs.BoardDialogRef.open(preUnits ? { units: preUnits } : {})
    },
    // 拼板工具弹框保存
    handleBoardConfirm(data) {
      // 修改拼板参数后需要清除DFM传值json
      this.pcbParams = Object.assign(this.pcbParams, { ...data, units: 2, dfm_sets: '' })
    },
    // 拼板工具弹框取消
    handleBoardCancel(preData) {
      this.pcbParams = Object.assign(this.pcbParams, preData || {})
    },
    // 重置拼板工具相关参数
    handleResetBoard() {
      // 重置时，不重置的字段
      const { topImage, botImage, length, width } = this.pcbParams
      this.pcbParams = Object.assign(this.pcbParams, FR4_BOARD_DEFAULT_FORM, { topImage, botImage, length, width, dfm_sets: '' })
    },

    // 计价
    async getPrice() {
      try {
        const { length, width, bcount } = this.pcbParams
        // 尺寸、数量没填时不能计价
        if (!length || !width || !bcount) return
        this.calcLoading = true

        const res = await this.getPcbPrice()
        const { detail = {} } = res
        const { pcb = {} } = detail
        const { suggest = {}, deltime, test, manufacture, m } = pcb

        this.pcbPrice = pcb
        this.priceTotal = res
        // 插入阶梯价提示
        this.priceTotal.ladderPriceTips = this.ladderPriceTips

        // 是否时外发
        this.manufacture = manufacture
        // 外发沉金厚度只能为1
        if (this.isShow.isFr4 && manufacture == 0 && this.pcbParams.spray === '沉金' && this.pcbParams.cjh != 1) {
          this.pcbParams.cjh = 1
          this.$topWarning.mergeFields('沉金厚度')
        }

        // 测试方式选项
        this.testOptions = suggest.test
        this.pcbParams.test = test
        // 上一次计价的板子面积
        this.pcbParams.old_area = m || ''

        // 生产周期
        this.pcbParams.deltime = deltime
        this.pcbParams.standard_deltime = ((suggest.deltime || []).find(item => item.name === deltime) || {}).standard_deltime || ''
      } finally {
        this.calcLoading = false
      }
    },
    // PCB 计价
    async getPcbPrice() {
      // want_bonus_activity：获取优惠券列表
      const params = formatPcbParams(this.pcbParams, { want_bonus_activity: 1 })
      return await getPcbPrice(params)
        .then(res => {
          if (!res) return {}
          const { retCode, result } = res
          return retCode === 0 ? result : {}
        })
    },
    // 获取少数处理方式费
    async getLackhandlefee() {
      try {
        const params = formatPcbParams(this.pcbParams, { lack_handle_type: 2 })
        const res = await getPcbPrice(params)
        if (!res) return ''
        const { retCode, result } = res
        return retCode === 0 ? result?.detail?.pcb?.lackhandlefee : ''
      } catch (error) {
        return ''
      }
    },

    // 需要等 pcbParams 初始化完成后再获取的数据
    delayInit() {
      // 初始化工程师信息
      // this.$refs.engineer_id && this.$refs.engineer_id.getList()
      // 初始化下单人
      this.$refs.orderman_id && this.$refs.orderman_id.init()
      // 初始化收货地址
      this.$refs.aid && this.$refs.aid.init()
    },
    // 获取快递选项
    handleGetExpressList() {
      this.$nextTick(() => {
        this.$refs.express.init()
      })
    },
    // 收货地址
    handleAddressChange(item) {
      const { id, telMobile, combinAddr, addr, province, city, district } = item || {}
      this.pcbParams = Object.assign(this.pcbParams, {
        aid: id,
        address: `${combinAddr}${addr}`,
        recevtel: telMobile,
        province,
        city,
        district
      })

      this.handleGetExpressList()
    },
    // 发票抬头
    handleInvoiceChange(item) {
      if (item) {
        const { invoiceType, type, invoiceTitle, taxCode } = item || {}
        this.pcbParams = Object.assign(this.pcbParams, {
          invoice: { 1: '增票全电', 2: '普票' }[invoiceType],
          invoice_kind: type,
          view_invoice_title: invoiceTitle,
          view_invoice_code: taxCode
        })
      }
    },

    // 显示抖动动画
    handleShake(key) {
      const ref = this.$refs[key]
      if (ref && ref.isShowShake) {
        // 显示抖动样式
        ref.isShowShake(true)
      }
    },
    // 滚动到指定字段
    async scrollIntoView(key) {
      // 当有折叠面板收起来时，先展开所有折叠面板再滚动
      const delayTime = this.collapseNames.length < defaultExpandCollapseNames.length ? 500 : 0
      this.collapseNames = [...defaultExpandCollapseNames]
      if (delayTime > 0) {
        await new Promise(resolve => {
          const timer = setTimeout(() => {
            resolve()
            clearTimeout(timer)
          }, delayTime)
        })
      }
      if (this.$refs[key]) {
        // 滚动到元素上面偏移55px的位置
        const top = this.$refs[key].$el.getBoundingClientRect().top
        scrollTop(top, -55)
      }
    },
    handleValidate(data) {
      data.forEach((item, index) => {
        const ref = this.$refs[item.key]
        if (ref && ref.isShowError) {
          // 显示错误提示样式
          ref.isShowError(true, index === 0)
        }
      })
      const fristItem = data[0]
      // 显示顶部提示(参数填写错误才显示)
      if (fristItem.topWarning) {
        this.$topWarning.error({ content: fristItem.tips, duration: 3000, closeAll: true })
      }
      this.scrollIntoView(fristItem.key)
      this.handleShake(fristItem.key)
    },

    // 返回旧版
    handleBackOldVersion() {
      const query = this.$route.query
      this.$router.push({ path: '/quote_new', query })
    }
  }
}
</script>

<style lang="scss">
@import '~@@/styles/directives.scss';
</style>
<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.pcb-quote {
  box-sizing: border-box;
  padding-bottom: 25px;
  font-size: 14px;
  min-height: 100vh;
}
.pcb-quote__container {
  margin: 15px auto 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-width: 1240px;
  width: 1240px;
  .pcb-quote__left {
    width: calc(100% - 400px - 12px);
  }
  .pcb-quote__right {
    margin-left: 12px;
    min-width: 400px;
    width: 400px;
  }
  @include media($size: sm) {
    width: 1240px;
    .pcb-quote__left {
      width: calc(100% - 400px - 12px);
    }
    .pcb-quote__right {
      width: 400px;
    }
  }
  @include media($size: md) {
    width: 1320px;
    .pcb-quote__left {
      width: calc(100% - 410px - 12px);
    }
    .pcb-quote__right {
      width: 410px;
    }
  }
  @include media($size: lg) {
    width: 1520px;
    .pcb-quote__left {
      width: calc(100% - 450px - 12px);
    }
    .pcb-quote__right {
      width: 450px;
    }
  }
}

.pcb-quote__collapse {
  border: 0;
  .pcb-quote__fileCollapseItem {
    &.is-active {
      .pcb-quote__fileHeader .pcb-quote__fileHeader__oldversion {
        margin-right: 12px;
      }
    }
    .pcb-quote__fileHeader {
      flex: 1;
      display: flex;
      align-items: center;
      .pcb-quote__fileHeader__label {
        >i {
          color: $--color-danger;
        }
      }
      .pcb-quote__fileHeader__operation,
      .pcb-quote__fileHeader__oldversion {
        display: flex;
        align-items: center;
        margin-left: 20px;
        font-size: 12px;
        font-weight: 400;
        >img {
          margin-right: 6px;
        }
      }
      .pcb-quote__fileHeader__operation {
        flex: 1;
      }
      .pcb-quote__fileHeader__oldversion {
        box-sizing: border-box;
        margin-right: 40px;
        padding: 0 10px;
        height: 28px;
        border-radius: $--border-radius-base2;
      }
    }
  }
  .pcb-quote__invoiceHeader {
    >span {
      margin-left: 12px;
      font-size: 12px;
      font-weight: 400;
      color: $--tips-color;
    }
  }
  .pcb-quote__smtInfoHeader {
    .pcb-quote__smtInfoHeader__img {
      display: block;
      width: 100%;
    }
    .pcb-quote__smtInfoHeader__text {
      margin-left: 12px;
      font-size: 12px;
      font-weight: 400;
      color: $--color-danger;
      text-decoration: underline;
    }
  }
}

</style>